































































































































































import Vue from 'vue'
import axios from 'axios'

import Loading from '@/components/helper-components/Loading.vue'
import { EmailReportSubscriptionForm, EmailReport, UserReportSubscription } from '@/interfaces/email-report'

export default Vue.extend({
  components: {
    Loading
  },

  props: {
    userId: Number
  },

  data () {
    return {
      showSubscriptionModal: false,
      initialLoading: false,
      isTestLoading: false,
      userReportsSubscriptions: [] as UserReportSubscription[],
      emailReports: [] as EmailReport[],
      subscriptionForm: {
        reportId: -1,
        subscriptionId: -1,
        active: false,
        regions: [],
        products: []
      } as EmailReportSubscriptionForm,
      subscriptionRegionOptions: [] as string[],
      subscriptionProductOptions: [] as string[]
    }
  },

  computed: {
    isTestButtonDisabled (): boolean {
      const { reportId, active, regions, products } = this.subscriptionForm
      return reportId < 0 || !active || ![regions, products].some(item => item.length)
    },

    currentReportDescription (): string {
      const currentReport = this.emailReports.find(report => report.id === this.subscriptionForm.reportId)
      return currentReport ? currentReport.description : ''
    }
  },

  watch: {
    userId (val) {
      if (val) {
        this.initData()
      }
    },

    emailReports (val) {
      if (val && val.length) {
        this.setSubscriptionForm(val[0])
      }
    }
  },

  created () {
    if (this.userId) {
      this.initData()
    }
  },

  methods: {
    async initData () {
      this.initialLoading = true
      this.isTestLoading = true
      try {
        const [emailReports, userReportsSubscriptions] = await Promise.all([
          axios.get(`${process.env.VUE_APP_API_URI}/email-reports`),
          axios.get(`${process.env.VUE_APP_API_URI}/users/${this.userId}/email-reports/subscriptions`)
        ])
        this.emailReports = emailReports.data
        this.userReportsSubscriptions = userReportsSubscriptions.data
        this.setSubscriptionForm(this.emailReports[0])
      } catch (error) {

      }
      this.initialLoading = false
      this.isTestLoading = false
    },

    resetSubscriptionForm () {
      this.subscriptionForm = {
        reportId: -1,
        subscriptionId: -1,
        active: false,
        regions: [],
        products: []
      }
    },

    setSubscriptionForm (reportData: EmailReport | undefined) {
      if (!reportData) {
        this.resetSubscriptionForm()
        return
      }

      this.$set(this.subscriptionForm, 'reportId', reportData.id)
      this.subscriptionRegionOptions = reportData.regionOptions
      this.subscriptionProductOptions = reportData.productOptions
      const targetSubscription = this.userReportsSubscriptions.find(subscription => subscription.reportId === reportData.id)
      if (targetSubscription) {
        this.$set(this.subscriptionForm, 'subscriptionId', targetSubscription.id)
        this.$set(this.subscriptionForm, 'products', targetSubscription.products)
        this.$set(this.subscriptionForm, 'regions', targetSubscription.regions)
        this.$set(this.subscriptionForm, 'active', targetSubscription.active)
      } else {
        this.resetSubscriptionForm()
        this.$set(this.subscriptionForm, 'reportId', reportData.id)
      }
    },

    onHandleReportChange (reportId: number) {
      const report = this.emailReports.find(report => report.id === reportId)
      this.setSubscriptionForm(report)
    },

    onCancelSubscriptionEdition () {
      this.showSubscriptionModal = false
      this.resetSubscriptionForm()
    },

    onUpdateSubscription () {
      const subscribed = this.userReportsSubscriptions.find(sub => sub.reportId === this.subscriptionForm.reportId)
      if (subscribed) {
        this.updateSubscription()
      } else {
        this.addSubscription()
      }
      this.showSubscriptionModal = false
    },

    addSubscription () {
      const { reportId, regions, products, active } = this.subscriptionForm
      try {
        axios.post(`${process.env.VUE_APP_API_URI}/email-reports/subscription`, {
          userId: this.userId,
          reportId,
          regions,
          products,
          active
        })
        this.$Message.success('Successfully subscribed to the eamil report!')
      } catch (error) {
        console.error(`Error subscribe user ${this.userId} to email report ${this.subscriptionForm.reportId}: ${error}`)
        this.$Message.error('Fail to subscribe to the email report!')
      }
    },

    updateSubscription () {
      const { regions, products, active, subscriptionId } = this.subscriptionForm
      try {
        axios.put(`${process.env.VUE_APP_API_URI}/email-reports/subscription/${subscriptionId}`, {
          regions,
          products,
          active
        })
        this.$Message.success('Successfully updated the subscription!')
      } catch (error) {
        console.error(`Error update the subscription to email report ${this.subscriptionForm.reportId} for user ${this.userId}: ${error}`)
        this.$Message.error('Fail to update subscription!')
      }
    },

    async testReport () {
      this.isTestLoading = true

      try {
        await axios.post(`${process.env.VUE_APP_API_URI}/email-reports/tests`, {
          email: this.$auth.getUser().email,
          subscriptionForm: this.subscriptionForm
        })
        this.$Message.success(`The report has been sent to your email, it may take several secons to arrive!`)
      } catch (error) {
        this.$Message.error(`Could not send report tests: ${error}`)
        console.error(error)
      } finally {
        this.isTestLoading = false
      }
    }
  }
})
